import React, { useState, useEffect } from "react";
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
  Card,
  CardBody,
  CardImg,
  CardTitle,
  Row,
  Col,
} from "reactstrap";
import { useRecoilState } from "recoil";
import { newState } from "../../Recoil/atom";
import api from "../../api";

const NewUserModal = () => {
  const [modal, setModal]         = useState(true);
  const [isNewUser, setIsNewUser] = useRecoilState(newState);
  const [loading, setLoading]     = useState(false);
  const username                  = localStorage.getItem("authUser") || "Trainer";
  
  // Check new user status on component mount
  useEffect(() => {
    const checkNewStatus = async () => {
      try {
        const response = await api.get("/v1/new-status", { withCredentials: true });
        if (response.data && response.data.new !== undefined) {
          setIsNewUser(response.data.new);
        }
      } catch (err) {
        console.error("Failed to fetch new user status:", err);
      }
    };
    
    checkNewStatus();
  }, [setIsNewUser]);

  const handleClose = async () => {
    setLoading(true);
    try {
      const response = await api.post("/v1/new-user", {}, { withCredentials: true });
      if (response.data && response.data.new !== undefined) {
        setIsNewUser(response.data.new);
      } else {
        setIsNewUser(0); // Fallback if response doesn't include new status
      }
    } catch (err) {
      console.error("Failed to update new user field:", err);
    } finally {
      setLoading(false);
      setModal(false);
    }
  };

  // Don't render modal if user is not new
  if (isNewUser === 0) {
    return null;
  }

  return (
    <Modal
      isOpen={modal}
      centered
      backdrop="static"
      keyboard={false}
      size="lg"
    >
      <ModalHeader toggle={handleClose}>
        {`Hello ${username}, welcome to Pokémon Radiance!`}
      </ModalHeader>
      <ModalBody style={{ background: "#1d222e", color: "#fff" }}>
        {/* Professor Oak Section */}
        <div className="text-center mb-5">
          <img
            src="/avatars/31.png"
            alt="Professor Oak"
            style={{ width: 120, marginBottom: 16 }}
          />
          <h5 style={{ color: "#ccc", maxWidth: 600, margin: "0 auto 1rem" }}>
            Welcome to Pokémon Radiance! To help start your journey, I’ve given you:
          </h5>
          <Row className="justify-content-center align-items-center" style={{ gap: "1.5rem" }}>
            <Col xs="auto" className="text-center">
              <img
                src="/items/ultraball.png"
                alt="Ultraball"
                style={{ width: 24 }}
              />
              <div style={{ color: "#fff", marginTop: 4 }}>×20</div>
            </Col>
            <Col xs="auto" className="text-center">
              <img
                src="/items/lure.png"
                alt="Lure"
                style={{ width:23 }}
              />
              <div style={{ color: "#fff", marginTop: 4 }}>×1</div>
            </Col>
            <Col xs="auto" className="text-center">
              <img
                src="/items/NormalPickaxe.png"
                alt="Pickaxe"
                style={{ width: 24 }}
              />
              <div style={{ color: "#fff", marginTop: 4 }}>×1</div>
            </Col>
          </Row>
          <p style={{ color: "#ccc", marginTop: "1rem" }}>
            I've already equipped your pickaxe so get started mining—check out the maps to find rocks to mine!
          </p>
        </div>

        {/* Color Variants Section */}
        <div className="text-center mb-5">
          <h6 style={{ color: "#fff", marginBottom: 16 }}>
            Color Variants in Pokémon Radiance
          </h6>
          <p style={{ color: "#aaa", marginBottom: 24 }}>
            Beyond Shiny, discover Diamond, Golden, Emerald, Sapphire, Ruby, and Shadow!
          </p>
          <Row className="justify-content-center g-3">
            {[
              { name: "Diamond",   sprite: "DiamondRayquaza" },
              { name: "Golden",    sprite: "GoldenGiratina" },
              { name: "Emerald",   sprite: "EmeraldYveltal" },
              { name: "Sapphire",  sprite: "SapphireLugia" },
              { name: "Ruby",      sprite: "RubyMewtwo" },
              { name: "Shadow",    sprite: "ShadowKyurem" }, 
            ].map((v) => (
              <Col key={v.name} xs="6" sm="4" md="3" lg="2">
                <Card
                  style={{
                    background: "#272d39",
                    border: "1px solid #444",
                    borderRadius: 12,
                  }}
                  className="h-100"
                >
                  <CardImg
                    top
                    src={`/sprites/${v.sprite}.png`}
                    alt={v.name}
                    style={{ padding: 8, background: "#1d222e" }}
                  />
                  <CardBody className="p-2 text-center">
                    <CardTitle tag="h6" style={{ color: "#fff", margin: 0 }}>
                      {v.name}
                    </CardTitle>
                  </CardBody>
                </Card>
              </Col>
            ))}
          </Row>
        </div>

        {/* Promo Info */}
        <div style={{ color: "#ccc", textAlign: "center" }}>
          <p>
            Promos can be claimed in many ways—but once a promo is released,
            no more of that Pokémon will be added. Miss it, and you’ll have to
            trade with other trainers. Check the current promo at{" "}
            <a href="/promo-center" style={{ color: "#4caf50" }}>
              Promo Center
            </a>
            .
          </p>
        </div>
      </ModalBody>
      <ModalFooter style={{ background: "#1d222e" }}>
        <Button color="primary" onClick={handleClose} disabled={loading}>
          {loading ? "Processing..." : "Let's Go!"}
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export default NewUserModal;
